<template id="different">
  <div class="outer-container">
    <div class="container">
      <h2 class="text-center header-font">
        How is this Bootcamp Different
      </h2>
      <div class="grid">
        <div class="flexing">
          <img src="../../assets/DataScience/Group 14 (1).svg" alt="" />
          <h3>
            Mix of both recorded and hands on sessions
          </h3>
        </div>

        <div class="flexing">
          <img src="../../assets/DataScience/Group 15.svg" alt="" />

          <h3>
            Get connected to peers with shared experiences and interests.
          </h3>
        </div>

        <div class="flexing">
          <img src="../../assets/DataScience/Group 16.svg" alt="" />

          <h3>
            Based on real life data & cases
          </h3>
        </div>

        <div class="flexing">
          <img src="../../assets/DataScience/Group 17.svg" alt="" />

          <h3>
            Chance to showcase work with a BD specific Dataset in front of
            potential employers
          </h3>
        </div>
        <div class="flexing">
          <img src="../../assets/DataScience/Group 22.svg" alt="" />

          <h3>
            We are giving our top 5 students an opportunity to land a job at the
            deep-tech startup Intelligent Machines
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.outer-container {
  background-color: #ececec;
  margin-top: 100px;
}
.header-font {
  padding-top: 100px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
}

.grid {
  padding-top: 60px;
  display: grid;

  grid-template-columns: repeat(5, 1fr);
  grid-gap: 50px;
  max-width: 1300px;
  margin: 0 auto;
  padding-bottom: 100px;
}
.grid h3 {
  padding: 40px;
  font-family: 'Manrope';
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 24px;
  color: #184dbd;
  padding-left: 20px;
}
.border-bottom h2 {
  border-bottom: 1px solid white;
  padding-bottom: 15px;
}
.grid h4 {
  text-transform: uppercase;
  font-family: 'Open Sans';
  font-size: 60px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 24px;
  color: #ffffff;
}
.flexing {
  background-color: white;
  min-height: 300px;
}
.flexing img {
  padding-top: 30px;
  padding-left: 20px;
}
.flex {
  display: inline-flex;
}
.flex .left {
  margin-right: 20px;
}
@media only screen and (max-width: 600px) {
  .grid {
    padding-top: 60px;
    display: grid;

    grid-template-columns: repeat(1, 1fr);
    grid-gap: 50px;
    max-width: 1300px;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .flexing {
    min-height: 200px;
  }
}
</style>
